import {get, post, postJson, downloadAttachment} from "@/utils/http";
import {SYS_APi_SCREENING_URL} from '@/utils/globals'

// 当月流程列表分页查询
export const pageQuery = p => postJson(SYS_APi_SCREENING_URL + "/newWorkFlow/pageQuery", p);

// 历史流程列表分页查询
export const historyPageQuery = p => postJson(SYS_APi_SCREENING_URL + "/newWorkFlow/historyPageQuery", p);

// 获取流程详情
export const detail = p => get(SYS_APi_SCREENING_URL + "/newWorkFlow/detail", p);

// 流程流水（含子流程列表）
export const getWorkflowListByParentId = p => get(SYS_APi_SCREENING_URL + "/newWorkFlow/getWorkflowListByParentId", p);

// 资质文件列表
export const getQualificationFiles = p => get(SYS_APi_SCREENING_URL + "/newWorkFlow/getQualificationFiles", p);

// 上传记录列表
export const getUploadFileList = p => get(SYS_APi_SCREENING_URL + "/newWorkFlow/getUploadFileList", p);

// 流程详情（含审核信息）
export const getAuditRecords = p => get(SYS_APi_SCREENING_URL + "/newWorkFlow/getAuditRecords", p);

// 关联商户列表（服务端分页）
export const getMerchantsByFlowId = p => postJson(SYS_APi_SCREENING_URL + "/newMerchant/pageQuery", p);

// 关联门店列表（服务端分页）
export const getStoresByFlowId = p => postJson(SYS_APi_SCREENING_URL + "/newStore/pageQuery", p);

// 下载文件
export const downloadFile = p => post(SYS_APi_SCREENING_URL + "/file/download", p);

// 模板下载
export const template = p => downloadAttachment(SYS_APi_SCREENING_URL + "/filedown/template", p);

// 查询申报期限
export const getTerm = p => post(SYS_APi_SCREENING_URL + "/term/getTerm", p);

// 获取流程详情（编辑）
export const getWorkflowById = p => post(SYS_APi_SCREENING_URL + "/workflow/getWorkflowById", p);

// 获取是否可上传支付业务许可证
export const getIsUploadPayBusinessLicense = p => get(SYS_APi_SCREENING_URL + "/newWorkFlow/getIsUploadPayBusinessLicense", p);

// 是否可渠道申请
export const getIsChannelApply = p => get(SYS_APi_SCREENING_URL + "/newWorkFlow/getIsChannelApply", p);

// 设置渠道、商户、门店加入时间, 特例: 门店退出的 设置 退出时间
export const setJoinDate = p => get(SYS_APi_SCREENING_URL + "/newWorkFlow/setJoinDate", p);